import {Outlet} from "react-router";
import {Alert} from "react-bootstrap";
import {useAuth} from "./AuthContext";

// Inside RequireAuth: signed in, but only site administrators get through.
export function RequireAdmin() {
    const {isAdmin} = useAuth();
    if (!isAdmin) {
        return <Alert variant="warning">This area is for site administrators.</Alert>;
    }
    return <Outlet/>;
}
